import { Spinner } from '@/components/ui';

/** Full-viewport loading state used while the session is resolving. */
export function FullScreenLoader() {
  return (
    <div className="grid min-h-dvh place-items-center bg-canvas text-primary">
      <Spinner size={32} />
    </div>
  );
}
